import {ASetDay, isCurrentSlot, PlaylistRemoteAppState} from '../../store';
import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NgRedux, Select} from '@angular-redux3/store';
import {combineLatest, Observable, of} from 'rxjs';
import {filter, map, pluck, switchMap} from 'rxjs/operators';

import {Days, TimeSlot} from '../../store/entities';
import {getCurrentDay} from '../../utils';
import {IScheduleState} from 'src/app/store/reducers/schedule.reducer';
import {Router} from '@angular/router';
import {EnumUserParam, IUserParams, IUserParamsState} from '../../store/reducers/user-params.reducer';

@Component({
  selector: 'mwo-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SchedulerPage implements OnInit {
  day: Days;
  activeDay$: Observable<string> = this.ngRedux.select('activeDay');
  schedule$: Observable<IScheduleState> = this.ngRedux.select('schedule');
  @Select('scheduleDay') schedule24$: Observable<TimeSlot>;
  @Select(['player', 'playerContextType']) context$: Observable<string>;
  @Select(['player', 'isPlaying']) isPlaying$: Observable<boolean>;
  @Select(['remote', 'name']) remoteName$: Observable<string>;
  @Select(['player', 'timeSlot']) currentSlot$: Observable<TimeSlot>;
  @Select('userParams') userParams$: Observable<IUserParamsState>;

  remoteScheduleEditParam: IUserParams;

  @Input() displayFullPage = true;

  arrayTimeSlot: Array<TimeSlot> = [];

  emptyList$ = of([]);

  slots$: Observable<TimeSlot[]> = combineLatest([this.schedule$, this.activeDay$]).pipe(
    map(([schedule, day]) => (schedule[day] || {}).slots || []),
  );

  currentSlotDay$: Observable<TimeSlot> = this.schedule$.pipe(
    pluck(getCurrentDay()),
    filter(Boolean),
    map(({ slots }) => slots.filter(isCurrentSlot)[0]),
    filter(Boolean),
  );

  // @ts-ignore
  isPlayingFromSchedule$: Observable<boolean> = this.context$.pipe(
    //tap((context) => console.log('context', context)),
    switchMap(context => {
      if (context === 'SCHEDULE_WEEKLY') {
        return this.isPlaying$;
      } else if (context === 'PLAYLIST') {
        return of(false);
      } else {
        return of(false);
      }
    }),
  );

  isCurrentDaySelected$: Observable<boolean> = this.activeDay$.pipe(
    map(activeDay => activeDay === getCurrentDay() || activeDay === Days.ALLDAY)
  );

  tmpObservable: Observable<TimeSlot>;
  slot24$: Observable<Array<TimeSlot>>;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private router: Router
  ) { }

  ngOnInit() {
    this.schedule24$.subscribe(res => {
      if (res) {
        this.arrayTimeSlot.push(res);
        this.tmpObservable = of(this.arrayTimeSlot[0]);
        this.slot24$ = this.tmpObservable.pipe(
          map(slot => slot.daySchedule.slots)
        );
      }
    }
    );

    //Here I am reversing the EnumUserParam in order to get a string value instead of a number, so I can compare it with the userParams
    const EnumUserParamReverse = Object.keys(EnumUserParam).reduce((acc, key) => {
      acc[EnumUserParam[key]] = key;
      return acc;
    }, {});

    this.userParams$.subscribe(userParams => {
      this.remoteScheduleEditParam = userParams.find(param => param.param === EnumUserParamReverse[EnumUserParam.REMOTE_SCHEDULE_EDIT]);
    });
  }

  onActiveDayChanged(day: Days = getCurrentDay()) {
    this.ngRedux.dispatch(ASetDay(day));
    this.day = day;
  }

  openEditInterface() {
    this.router.navigate(['scheduler-modifier'])
  }

  isSchedulerEditable() {
    return this.remoteScheduleEditParam && this.remoteScheduleEditParam.active;
  }

  back() {
    this.router.navigate(['library'])
  }
}
